export const FETCH_ORDER_TRANSACTIONS_REQUEST =
  "API/ENTITIES/ORDER_TRANSACTIONS/FETCH_REQUEST";
export const FETCH_ORDER_TRANSACTIONS_REQUEST_SUCCESS =
  "API/ENTITIES/ORDER_TRANSACTIONS/FETCH_REQUEST_SUCCESS";
export const FETCH_ORDER_TRANSACTIONS_REQUEST_FAILURE =
  "API/ENTITIES/ORDER_TRANSACTIONS/FETCH_REQUEST_FAILURE";
